module.exports = __webpack_public_path__ + "ptc_momoro_L1.a948efa5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_L1.jpg
// module id = NvXT
// module chunks = 0